import React, { useEffect, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { UncontrolledTooltip } from 'reactstrap';
import { PerformanceLabData } from '../PerformanceLabData';
import { PerformanceOppDiag } from '../PerformanceOppDiag';

const PerformaceMetrics = (props) => {
  const [selectedDeviceType, setSelectedDeviceType] = useState('mobile');
  const [metrics, setMetrice] = useState([]);
  const {
    mobileMetrics,
    desktopMetrics,
    activeTab,
    mobileLabData,
    desktopLabData,
    desktopOpportunities,
    mobileOpportunities,
    desktopDiagnostics,
    mobileDiagnostics,
    url,
  } = props;

  useEffect(() => {
    getMetricsData(selectedDeviceType);
  }, []);
  const getColor = (tempScore) => {
    let color = '#f9a02e';
    if (tempScore < 50) color = '#f24c40';
    if (tempScore > 89) color = '#43bac5';
    return color;
  };

  const getBackgroundColor = (score) => {
    let bgColor = '#fff6e6';
    if (score < 50) bgColor = '#ffece6';
    if (score > 89) bgColor = '#e8faf0';
    return bgColor;
  };

  const getMetricsData = (type) => {
    const { performance, accessibility, seo, pwa, bestPractice } =
      type === 'mobile' ? mobileMetrics : desktopMetrics;
    const tempArr = [
      { name: 'Performace', value: parseInt(performance * 100) },
      { name: 'Accessiblity', value: parseInt(accessibility * 100) },
      { name: 'Best Practices', value: parseInt(bestPractice * 100) },
      { name: 'SEO', value: parseInt(seo * 100) },
      { name: 'PWA', value: parseInt(pwa * 100) },
    ];
    setMetrice(tempArr);
  };
  const mapLabData = { mobile: mobileLabData, desktop: desktopLabData };
  const mapOppur = {
    mobile: mobileOpportunities,
    desktop: desktopOpportunities,
  };
  const mapDiag = { mobile: mobileDiagnostics, desktop: desktopDiagnostics };
  const handleToggleDeviceMetrice = (type) => {
    setSelectedDeviceType(type);
    getMetricsData(type);
  };
  return (
    <>
      <div className='d-flex mt-5'>
        <div
          className={`devicePerformance ${
            selectedDeviceType === 'mobile' ? 'activeTabDevice ' : ''
          }`}
          onClick={() => handleToggleDeviceMetrice('mobile')}
        >
          MOBILE
        </div>
        <div
          className={`devicePerformance ${
            selectedDeviceType === 'desktop' ? 'activeTabDevice' : ''
          }`}
          onClick={() => handleToggleDeviceMetrice('desktop')}
        >
          DESKTOP
        </div>
      </div>
      <div className='p-5 border bg-white'>
        <div className='d-flex justify-content-between align-items-top'>
          <div>
            <div className='text-size-24 color-indigo-900 mb-1 fw-5'>
              Performance Metrics
            </div>
            <span className='text-size-12 color-indigo-900'>
              Powered by google lighthouse{' '}
              <span
                className='moreInfoTooltip static ml-2'
                id='Tooltip-performace-metrics'
              >
                ?
              </span>
              <UncontrolledTooltip
                placement='right'
                target='Tooltip-performace-metrics'
                autohide={false}
              >
                These metrics are generated using{' '}
                <a
                  target='_blank'
                  href='https://developers.google.com/speed/pagespeed/insights/'
                >
                  Google lighthouse.
                </a>
              </UncontrolledTooltip>
            </span>
          </div>
        </div>
        <div className='d-flex justify-content-between pt-5'>
          {metrics.map((v) => (
            <div className='widht-71px'>
              <CircularProgressbar
                value={v.value === 0 ? 100 : v.value}
                text={v.value === 0 ? '?' : v.value}
                background={true}
                styles={{
                  path: {
                    stroke: `${getColor(v.value)}`,
                    strokeLinecap: 'round',
                    transition: 'stroke-dashoffset 0.5s ease 0s',
                  },
                  trail: {
                    stroke: '#ffffff',
                    strokeLinecap: 'butt',
                    transform: 'rotate(0.25turn)',
                    transformOrigin: 'center center',
                  },
                  text: {
                    fill: getColor(v.value),
                    fontSize: '16px',
                    fontWeight: v.value === 0 ? 'normal' : 'bold',
                  },
                  background: {
                    fill: getBackgroundColor(v.value),
                  },
                }}
              />
              <div className='text-size-10 text-center mt-2'>{v.name}</div>
            </div>
          ))}
          <div className='scoreInfo'>
            <div class='infoItem'>
              <div class='dot line'></div>{' '}
              <span className='text-size-12 color-indigo-900'>0-49</span>{' '}
            </div>
            <div class='infoItem'>
              <div class='dot dotYello line'></div>{' '}
              <span className='text-size-12 color-indigo-900'>50-89</span>{' '}
            </div>
            <div class='infoItem'>
              <div class='dot dotGreen line'></div>{' '}
              <span className='text-size-12 color-indigo-900'>90-100</span>{' '}
            </div>
          </div>
        </div>
        <PerformanceLabData data={mapLabData[selectedDeviceType]} url={url} />
        <PerformanceOppDiag
          dataOppor={mapOppur[selectedDeviceType]}
          dataDiag={mapDiag[selectedDeviceType]}
        />
      </div>
    </>
  );
};

export default PerformaceMetrics;
